import ECharts from 'vue-echarts/components/ECharts';
import moment from 'moment';
import { each, has, isEmpty, sortBy, get } from 'lodash';
import { numberFormat } from 'utils';

import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/graphic';

export default {
  props: {
    measurements: {
      required: true,
      default: null,
    },
    chartDetails: {
      type: Object,
      required: false,
      defalt: null,
    },
    measurementDetails: {
      type: Object,
      required: false,
      defalt: null,
    },
    trackable: {
      required: false,
      default: null,
    },
  },
  components: {
    chart: ECharts,
  },
  data() {
    return {
      group: null,
      chart: null,
      labels: null,
      weightUnit: null,
      graph: null,
    };
  },
  methods: {
    formatTooltip(params, ticket, callback) {
      setTimeout(() => {
        let html = '';
        const sorted = sortBy(params, ['data.seq']);
        each(sorted, (param, index) => {
          if (index === 0) html += `${param.axisValue}<br/>`;
          const percent = has(param, 'data.percent') ? ` (${numberFormat(param.data.percent, 2)}%)` : '';
          html += `${param.marker} ${param.seriesName}: ${numberFormat(param.data.value, 2)} ${param.data.unit}${percent}<br/>`;
        });
        callback(ticket, html);
      }, 200);
      return this.labels.loading;
    },
    formatLabel(measurement, formatDate = 'DD/MM/YYYY', formatTime = 'HH:mm') {
      const timestamp = has(measurement, 'measurement_timestamp') ? measurement.measurement_timestamp : '';
      const date = moment(timestamp).format(formatDate);
      const time = moment(timestamp).format(formatTime);
      return `${date}\n${time}`;
    },
    prepareData() {},
    prepareGraph() {},
  },
  computed: {
    trackedMeasurements() {
      return get(this.trackable, `${this.group}.charts.${this.chart}.trackedMeasurements`);
    },
  },
  mounted() {
    this.prepareGraph();
  },
  watch: {
    measurements(newVal) {
      if (!isEmpty(newVal)) {
        this.prepareGraph();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/echarts-template.js